var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRickshaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.18V11.72C21 11.25 20.84 10.8 20.54 10.44L16.6 5.72C16.22 5.26 15.66 5 15.06 5H3C1.9 5 1 5.9 1 7V15C1 16.1 1.9 17 3 17H3.18C3.6 18.16 4.7 19 6 19C7.3 19 8.4 18.16 8.82 17H17.19C17.6 18.16 18.7 19 20.01 19C21.67 19 23.01 17.66 23.01 16C23 14.7 22.16 13.6 21 13.18ZM18.4 11H16V8.12L18.4 11ZM3 7H7V11H3V7ZM6 17C5.45 17 5 16.55 5 16C5 15.45 5.45 15 6 15C6.55 15 7 15.45 7 16C7 16.55 6.55 17 6 17ZM9 15V13H12V11H9V7H14V15H9ZM20 17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRickshaw);
export default __webpack_public_path__ + "static/media/rickshaw.6b4dbdcbcf3329f72ea82359990ea4d4.svg";
export { ForwardRef as ReactComponent };